import React from 'react'
import { Box, Center, Button, Heading, SimpleGrid } from '@chakra-ui/react'
import bg_inchilza from '../assets/inchilza-dance-bg.webp'

import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { toggleContactForm, setContactFormCustomText } from '../store/appSlice'

const HeroImage = () => {

    const dispatch = useDispatch()
    const { t } = useTranslation()

    const reserveSpot = () => {
        dispatch(setContactFormCustomText(t('common.reserve')))
        dispatch(toggleContactForm())
    }

  return (
    <Box
        height={{base:'55vh', md:'88vh'}}
        width={'100%'}
        bgGradient={'linear(to-tr, pink.300, red.400)'}
        bgImg={bg_inchilza}
        bgSize={'cover'}
        bgPosition={'center center'}
        >
            
            <Center
                flexDirection={'column'}
                height={'100%'}
                justifyContent={'space-between'}
                zIndex={2}
                >
                <Center
                    flexDirection={'column'}>
                    <Heading
                        fontSize={{base:'2xl',md:'4xl'}}
                        color={'white'}
                        textShadow="0 0 4px rgba(0,0,0, 0.8)"
                        paddingTop={{base: '13vh', md:'18vh'}}
                        zIndex={3}
                        textAlign={'center'}
                        >
                        {t('home.season')}
                    </Heading>
                </Center>
                <SimpleGrid
                    marginTop={{base:'auto'}}
                    marginBottom={'4vh'}
                    columns={{base:1, sm:2}}
                    gap={'3vw'}>
                    <Button
                        bg={'rgba(255,255,255,0.3)'}
                        backdropFilter={'blur(10px)'}
                        onClick={reserveSpot}
                        >
                        {t('home.reserve')}
                    </Button>
                     <Button
                        bg={'rgba(255,255,255,0.3)'}
                        backdropFilter={'blur(10px)'}
                        onClick={reserveSpot}
                        >
                        {t('home.contact')}
                    </Button>
                </SimpleGrid>
            </Center>
      
    </Box>
  )
}

export default HeroImage
